import React from 'react';
import { Button, ButtonProps, useToast } from '@chakra-ui/react';
import { PiCopyBold } from 'react-icons/pi';

interface CopyLinkButtonProps extends Omit<ButtonProps, 'onClick'> {
  url: string;
}

export const CopyLinkButton = ({ url, ...buttonProps }: CopyLinkButtonProps) => {
  const toast = useToast();

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(url);
    toast({
      status: 'success',
      title: 'Link copiado',
      position: 'bottom-right',
      description: 'El link de pago se copió al portapapeles.',
    });
  };

  return (
    <Button
      leftIcon={<PiCopyBold />}
      colorScheme="button-primary"
      borderRadius="full"
      size="sm"
      onClick={handleCopyLink}
      {...buttonProps}
    >
      Copiar link
    </Button>
  );
};
